import { Component } from 'react';

export default class Polyline extends Component {
  static nonGeodesicPolyline = [];

  static getRouteEndpoints(route) {
    if (!Array.isArray(route && route.path)) {
      return null;
    }

    const waypoints = route.path
      .map(waypoint => waypoint && waypoint.address)
      .filter(address => address && address.lat != null && address.lng != null)
      .map(address => ({ lat: Number(address.lat), lng: Number(address.lng) }))
      .filter(point => Number.isFinite(point.lat) && Number.isFinite(point.lng));

    if (waypoints.length < 2) {
      return null;
    }

    return {
      origin: waypoints[0],
      destination: waypoints[waypoints.length - 1],
    };
  }

  static decodePolyline(encodedPath) {
    if (typeof encodedPath !== 'string' || encodedPath.length === 0) {
      return [];
    }

    let index = 0;
    let lat = 0;
    let lng = 0;
    const coordinates = [];

    while (index < encodedPath.length) {
      let shift = 0;
      let result = 0;
      let byte = null;

      do {
        byte = encodedPath.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);

      const deltaLat = (result & 1) ? ~(result >> 1) : (result >> 1);
      lat += deltaLat;

      shift = 0;
      result = 0;

      do {
        byte = encodedPath.charCodeAt(index++) - 63;
        result |= (byte & 0x1f) << shift;
        shift += 5;
      } while (byte >= 0x20);

      const deltaLng = (result & 1) ? ~(result >> 1) : (result >> 1);
      lng += deltaLng;

      coordinates.push({ lat: lat / 1e5, lng: lng / 1e5 });
    }

    return coordinates;
  }

  static getPolylinePoints(route) {
    const drivenRoute = route && route.driven_route ? route.driven_route : null;
    const overviewPolyline = drivenRoute && (
      (drivenRoute.overview_polyline && drivenRoute.overview_polyline.points) ||
      (Array.isArray(drivenRoute.routes) && drivenRoute.routes[0] && drivenRoute.routes[0].overview_polyline && drivenRoute.routes[0].overview_polyline.points)
    );
    const drivenRoutePoints = Polyline.decodePolyline(overviewPolyline);
    const endpoints = Polyline.getRouteEndpoints(route);

    if (drivenRoutePoints.length > 1 && endpoints) {
      const findClosestIndex = targetPoint => {
        let closestIndex = -1;
        let closestDistance = Number.POSITIVE_INFINITY;

        drivenRoutePoints.forEach((point, index) => {
          const distance = Math.hypot(point.lat - targetPoint.lat, point.lng - targetPoint.lng);
          if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      };

      const originIndex = findClosestIndex(endpoints.origin);
      const destinationIndex = findClosestIndex(endpoints.destination);

      if (originIndex >= 0 && destinationIndex >= 0) {
        const startIndex = Math.min(originIndex, destinationIndex);
        const endIndex = Math.max(originIndex, destinationIndex);
        const trimmedRoutePoints = drivenRoutePoints.slice(startIndex, endIndex + 1);

        if (trimmedRoutePoints.length > 1) {
          return trimmedRoutePoints;
        }
      }
    }

    if (drivenRoutePoints.length > 1) {
      return drivenRoutePoints;
    }

    if (Array.isArray(route && route.path)) {
      return route.path
        .map(waypoint => waypoint && waypoint.address)
        .filter(address => address && address.lat != null && address.lng != null)
        .map(address => ({ lat: Number(address.lat), lng: Number(address.lng) }))
        .filter(point => Number.isFinite(point.lat) && Number.isFinite(point.lng));
    }

    return [];
  }

  renderPolylines() {
    const { map, maps, routes } = this.props;
    const hexColors = ['#FF0000', '#3299CC', '#912CEE', '#E3701A', '#ECC8EC', '#FFE303', '#7FFFD4', '#87421F', '#EE00EE', '#5DFC0A'];

    Polyline.nonGeodesicPolyline.forEach(polyline => polyline.setMap(null));

    routes.forEach((route, index) => {
      const markers = Polyline.getPolylinePoints(route);

      if (markers.length <= 1) {
        return;
      }

      const poly = addPoly(markers, hexColors[index % hexColors.length], 0.7, 3);
      Polyline.nonGeodesicPolyline[index] = poly;
      Polyline.nonGeodesicPolyline[index].setMap(map);
    });

    function addPoly(coorArray, sColor, sOpacity, weight) {
      const poly = new maps.Polyline({
        path: coorArray,
        geodesic: false,
        strokeColor: sColor,
        strokeOpacity: sOpacity,
        strokeWeight: weight
      });
      return poly;
    }
  }

  render() {
    this.renderPolylines();
    return null;
  }
}
